"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contactInfosLoaded = exports.getContactInfos = exports.contactInfos = void 0;
exports.findContactInfo = findContactInfo;
exports.findByPerson = findByPerson;
exports.findPrimaryByPerson = findPrimaryByPerson;
exports.loadContactInfoFormData = loadContactInfoFormData;
const lodash_1 = require("lodash");
const contactInfos = (state) => state.contactInfos;
exports.contactInfos = contactInfos;
const getContactInfos = (state) => (0, exports.contactInfos)(state).contactInfos;
exports.getContactInfos = getContactInfos;
const contactInfosLoaded = (state) => (0, exports.contactInfos)(state).contactInfosLoaded;
exports.contactInfosLoaded = contactInfosLoaded;
function findContactInfo(contactInfos, contactInfoId) {
    return (0, lodash_1.find)(contactInfos, (c) => c.id === contactInfoId);
}
function findByPerson(contactInfos, id) {
    // Ensure id is a number to guarantee === operator works correctly
    const numericId = typeof id === 'string' ? parseInt(id, 10) : id;
    return (0, lodash_1.find)(contactInfos, (c) => c.personId === numericId);
}
function findPrimaryByPerson(contactInfos, personId) {
    // Ensure personId is a number to guarantee === operator works correctly
    const numericPersonId = typeof personId === 'string' ? parseInt(personId, 10) : personId;
    return (0, lodash_1.find)(contactInfos, (c) => c.isPrimary && c.personId === numericPersonId);
}
function loadContactInfoFormData(contactInfo) {
    const defaultContactValues = {
        addressCountry: 'United States',
        phoneNumberLabel1: 'mobile',
        phoneNumberLabel2: 'home',
        isAddressPrivate: false,
        isEmailAddressPrivate: false,
        isPhoneNumber1Private: false,
        isPhoneNumber2Private: false,
        isUser: false,
    };
    if (contactInfo && Object.keys(contactInfo).length > 0) {
        return {
            ...contactInfo,
            addressCountry: contactInfo.addressCountry || 'United States',
            phoneNumberLabel1: contactInfo.phoneNumberLabel1 || 'mobile',
            phoneNumberLabel2: contactInfo.phoneNumberLabel2 || 'home',
            isAddressPrivate: contactInfo.isAddressPrivate || false,
            isEmailAddressPrivate: contactInfo.isEmailAddressPrivate || false,
            isPhoneNumber1Private: contactInfo.isPhoneNumber1Private || false,
            isPhoneNumber2Private: contactInfo.isPhoneNumber2Private || false,
            isUser: false,
        };
    }
    else {
        return defaultContactValues;
    }
}
